export const BUTTONS_NAMES = [
  { label: 'Last 24h', value: 1 },
  { label: 'Daily', value: 0 },
  { label: 'Last seven days', value: 7 },
  { label: 'Last 30 Days', value: 30 },
  { label: 'Last 60 Days', value: 60 },
  { label: 'Last 90 Days', value: 90 }
];
export const NOT_FOUND = {
  mappedNames: 'Not defined',
  yAxisValue: 0,
  unit: 'NA'
};
export const CHART_GROUPS = {
  ELECTRICAL: 'electrical',
  ENVIRONMENTAL: 'environmental',
  POWER_QUALITY: 'powerQuality'
};
export const DEFAULT_FILTRATION_VALUE = {
  ELECTRICAL: 'currentRms',
  POWER_QUALITY: 'currentThdTotal'
};

export const ELECTRICAL_GROUPS = [
  {
    names: ['activeEnergy', 'activeEnergyTotal'],
    mappedNames: {
      activeEnergy: 'Active Energy',
      activeEnergyTotal: 'Active Energy Total'
    },
    unit: 'W',
    yAxisValue: 0
  },
  {
    names: ['voltage', 'voltageFundamental', 'voltageRms', 'voltageMin', 'voltageMax'],
    mappedNames: {
      voltage: 'Voltage',
      voltageFundamental: 'Voltage Current',
      voltageRms: 'Voltage RMS',
      voltageMin: 'Voltage Min',
      voltageMax: 'Voltage Max'
    },
    unit: 'V',
    yAxisValue: 1
  },
  {
    names: ['voltagePhase', 'currentPhase'],
    mappedNames: {
      voltagePhase: 'Voltage Phase',
      currentPhase: 'Current Phase'
    },
    unit: '\u00B0',
    yAxisValue: 2
  },
  {
    names: ['current', 'currentFundamental', 'currentRms'],
    mappedNames: {
      current: 'Current',
      currentFundamental: 'Current Fundamental',
      currentRms: 'Current RMS'
    },
    unit: 'A',
    yAxisValue: 3
  },
  {
    names: ['reactivePower', 'activePower', 'apparentEnergy', 'apparentEnergyTotal'],
    mappedNames: {
      reactivePower: 'Reactive Power',
      activePower: 'Active Power',
      apparentEnergy: 'Apparent Energy',
      apparentEnergyTotal: 'Total Apparent Energy'
    },
    unit: 'VA',
    yAxisValue: 4
  },
  {
    names: ['reactiveEnergy', 'reactiveEnergyTotal', 'powerFactor'],
    mappedNames: {
      reactiveEnergy: 'Reactive Energy',
      reactiveEnergyTotal: 'Total Reactive Energy',
      powerFactor: ' Power Factor'
    },
    unit: 'VAr',
    yAxisValue: 5
  },
  {
    names: ['currentThdTotal'],
    mappedNames: {
      currentThdTotal: 'Total Current THD'
    },
    unit: '%',
    yAxisValue: 6
  }
];

export const POWER_QUALITY_MAPPED_NAMES = {
  voltageThd: 'Voltage THD',
  voltageDip: 'Voltage Dip',
  voltageSwell: 'Voltage Swell',
  currentThdTotal: 'Current THD Total'
};

export const ELECTRICAL_ATTRIBUTES_SUBGROUPS = {
  power: {
    series: ['reactivePower', 'activePower', 'activeEnergy', 'activeEnergyTotal'],
    name: 'power'
  },
  voltage: {
    series: ['voltage', 'voltageFundamental', 'voltageRms', 'voltageMin', 'voltageMax'],
    name: 'voltage'
  },
  phase: {
    series: ['voltagePhase', 'currentPhase'],
    name: 'phase'
  },
  current: {
    series: ['current', 'currentFundamental', 'currentRms'],
    name: 'current'
  },
  apparentEnergy: {
    series: ['apparentEnergy', 'apparentEnergyTotal'],
    name: 'apparent energy'
  },
  reactive: {
    series: ['reactiveEnergy', 'reactiveEnergyTotal', 'powerFactor'],
    name: 'reactive'
  },
  thd: {
    series: ['currentThdTotal'],
    name: 'thd'
  }
};
export const GROUPS = {
  ELECTRICAL: {
    activeEnergy: 'Active Energy',
    activeEnergyTotal: 'Active Energy Total',
    voltage: 'Voltage',
    voltageFundamental: 'Voltage Current',
    voltageRms: 'Voltage RMS',
    voltageMin: 'Voltage Min',
    voltageMax: 'Voltage Max',
    voltagePhase: 'Voltage Phase',
    currentPhase: 'Current Phase',
    current: 'Current',
    currentFundamental: 'Current Fundamental',
    currentRms: 'Current RMS',
    reactivePower: 'Reactive Power',
    activePower: 'Active Power',
    apparentEnergy: 'Apparent Energy',
    apparentEnergyTotal: 'Total Apparent Energy',
    reactiveEnergy: 'Reactive Energy',
    reactiveEnergyTotal: 'Total Reactive Energy',
    powerFactor: 'Power Factor',
    currentThdTotal: 'Total Current THD'
  },
  POWER_QUALITY: {
    voltageThd: 'Voltage THD',
    voltageDip: 'Voltage Dip',
    voltageSwell: 'Voltage Swell',
    currentThdTotal: 'Current THD Total'
  }
};
